import InternalEvent from "../constants/internalEvent.js";
import InternalEventBus from "../utils/internalEventBus.js";
var TYPES = require('../../../src-client-lib/api/type-ids.js');

class IdentityAccessService {
  constructor() {
    this.user = null;
  }

  updateUser(currentUser, callback) {
    let promise = new Promise((resolve, reject) => {
      smashClient.updateUser(this.user, currentUser, (response) => {
        // now change user object to modified one(can find in the response object)

        let createdUser = response.user;
        if (response.typeId == TYPES.UserUpdated) {
          resolve("User profile has successfully updated");
        }
        else if (response.typeId == TYPES.UpdateUserRejected) {
          resolve("User profile failed to updated");
        }
      });
    });
    return promise;
  }

  login(userId, password, callback) {
    let promise = new Promise((resolve, reject) => {
      smashClient.login(userId, password, (response) => {
        if (response.status === 0) {
          this.user = response.user;
          this.user["name"] = `${this.user.firstName} ${this.user.lastName}`;
        }
        InternalEventBus.publish(InternalEvent.App.USER_STATUS_UPDATED);
        resolve(response);
      });
    });
    return promise;
  }

  logout() {
    this.user = null;

    // TODO: implement
    //ExternalEventBus.publish(ExternalEvent.USER_LOGOUT, eventPayload);
    InternalEventBus.publish(InternalEvent.App.USER_STATUS_UPDATED);

    // redirect to home
    document.location.href = "/login";
  }

  createUser(user) {
    return new Promise((resolve, reject) => {
      $.ajax({
        method: "post",
        url: window.smash.env.webServer + "/user",
        data: user,
      }).done(response => {
        response = JSON.parse(response);
        if (response.typeId == TYPES.RegisterUserResponse && response.responseType == 0) {
          resolve();
        } else {
          reject();
        }
      });
    });
  }

  sendResetPasswordRequest(userEmail) {
    return new Promise((resolve, reject) => {
      $.ajax({
        method: "post",
        url: window.smash.env.webServer + "/forgotPassword",
        data: {
          email: userEmail
        },
      }).done(response => {
        response = JSON.parse(response);
        if (response.typeId == TYPES.ForgotPasswordResponse && response.responseType == 0) {
          resolve();
        } else {
          reject();
        }
      });
    });
  }

  isUserLoggedin() {
    return this.user !== null;
  }

  updateUserCredential(oldPassword, newPassword, callback) {
    let promise = new Promise((resolve, reject) => {
      smashClient.updateUserCredential(oldPassword, newPassword, (status) => {
        // now change user object to modified one(can find in the response object)

        if (status.responseType == 0) {
          console.log("Password has been updated successfully");
          resolve("Your password has been updated successfully");
        }
        else {
          console.log("Password has failed to update");
          resolve("Your password has failed to update");
        }
      });
    });
    return promise;
  }

  getUserProfile() {
    return JSON.parse(JSON.stringify(this.user));
  }

  findUserByUserId(userId) {
    return new Promise((resolve, reject) => {
      smashClient.searchUserByUserId(userId, response => {
        const user = response.data.length === 1 ? response.data[0] : null;
        resolve(user);
      });
    });
  }

  getApiKeys() {
    return new Promise((resolve, reject) => {
      resolve([{
        key: '4e964f3d-491f-377e-15fe-c08083cec7e5"',
        expire: null,
      },
      {
        key: '4e964f3d-15fe-377e-15fe-c08083cec7e5"',
        expire: null,
      }
        ,
      {
        key: '4e964f3d-491f-491f-15fe-c08083cec7e5"',
        expire: null,
      }
      ])
      smashClient.getApiKeys(response => {

      })
    });
  }

  deleteApiKey(apiKey) {
    return new Promise((resolve, reject) => {
      resolve();
      smashClient.deleteApiKey(response => {

      })
    });
  }
}

const instance = new IdentityAccessService();
export default instance;


// WEBPACK FOOTER //
// ./src/core/services/identityAccessService.js